import { Component } from '@angular/core';
import {
  Data, Subscription, PriceCalculationService, SummaryService,
  DataLoaderService, ProgressBarService, CommonDataService, SortingService, SummaryValidationService, AlternateOptionsService
} from '../expert-screen-components/expert-service-call.index';
import * as _ from 'lodash';

@Component({
  selector: 'alternate-popup',
  templateUrl: './alternate-options.template.html',
  styleUrls: ['./alternate-options.component.css'],
})
export class AlternateScreenComponent {
  public packageEquipments = [];
  public suggestionList = [];
  public subscription: Subscription;
  public selectCode: any;
  public selectedItem: Data[] = [];
  public colorOptions = [];
  public addColorOptions = [];
  public rim = [];
  public upholstery = [];
  public trim = [];
  public factoryOptions: Data[];
  public additionalColorOptions: Data[];
  public packageOptions: Data[];
  public localOptions: Data[];
  public localPackageOptions: Data[];
  public standardOptions: Data[];
  public icon = "gray";
  public acceptFlag: boolean = false;
  public errorMessage: any;
  public tempSuggestionList = [];
  private alternateFactory: Data[] = [];
  private alternateLocal: Data[] = [];
  private alternatePackage: Data[] = [];
  private alternateLocalPackage: Data[] = [];
  private alternateStandard: Data[] = [];
  private selectedIndex: string = "item";
  private equipmentList: string;
  private showAcceptMandatory: boolean;
  public addedMsgs: any;
  public deletedMsgs: any;
  public addedCodes: any;
  public updateCodes: any;
  public deletedCodes: any;
  public configurationIdIndex:any

  constructor(private priceCalculationService: PriceCalculationService, private sortingService: SortingService,
    private dataLoaderService: DataLoaderService, private progressBarService: ProgressBarService,
    private commonDataService: CommonDataService, private summaryService: SummaryService, private alternateOptionsService: AlternateOptionsService,
    private summaryValidationService: SummaryValidationService) {
    this.colorOptions = this.dataLoaderService.data.color;
    this.addColorOptions = this.dataLoaderService.data.additionalColor;
    this.rim = this.dataLoaderService.data.rim;
    this.upholstery = this.dataLoaderService.data.upholstery;
    this.trim = this.dataLoaderService.data.trim;
    this.factoryOptions = this.dataLoaderService.data.facOptions;
    this.packageOptions = this.dataLoaderService.data.packages;
    this.localOptions = this.dataLoaderService.data.options;
    this.localPackageOptions = this.dataLoaderService.data.localPackagesList;
    this.standardOptions = this.dataLoaderService.data.stdOpt;
    this.showAcceptMandatory = true;
    this.subscription = this.commonDataService.notifyObservableAltErrMsg$.subscribe((res) => {
      this.errorMessage = res;
    });
  }

  ngAfterContentInit() {
    this.getAlternateOptions();
    if (this.dataLoaderService.vehicleInfo.urlFlag === '2') {
      this.getSummaryData();
    }
  }

  /**
   * To get the alternate options for a particular package option from service
   * @param index
   * @returns none
   */
  getAlternateOptions() {
    this.subscription = this.commonDataService.getSuggestion().subscribe(selectedOption => {
      this.suggestionList = [];
      if (this.dataLoaderService.vehicleInfo.urlFlag === '3') {
        let tempAdded = selectedOption.addedCodes;
        let tempDeleted = selectedOption.deletedCodes;
        let tempUpdated = selectedOption.updateCodes;
        selectedOption.addedCodes = [];
        selectedOption.deletedCodes = [];
        selectedOption.updateCodes = [];
        for (let i = 0; i < tempDeleted.length; i++) {
          let flagCountDel = 0;
          for (let j = 0; j < this.localOptions.length; j++) {
            if (tempDeleted[i].code === this.localOptions[j].code) {
              flagCountDel++;
            }
          }
          if (flagCountDel > 0) {
            selectedOption.deletedCodes.push(tempDeleted[i]);
          }
        }
        for (let i = 0; i < tempAdded.length; i++) {
          let flagCountAdd = 0;
          for (let j = 0; j < this.localOptions.length; j++) {
            if (tempAdded[i].code === this.localOptions[j].code) {
              flagCountAdd++;
            }
          }
          if (flagCountAdd > 0) {
            selectedOption.addedCodes.push(tempAdded[i]);
          }
        }
        for (let i = 0; i < tempUpdated.length; i++) {
          let flagCountAdd = 0;
          for (let j = 0; j < this.localOptions.length; j++) {
            if (tempUpdated[i].code === this.localOptions[j].code) {
              flagCountAdd++;
            }
          }
          if (flagCountAdd > 0) {
            selectedOption.updateCodes.push(tempUpdated[i]);
          }
        }
        this.suggestionList = selectedOption;
        this.dataLoaderService.addedCodes = selectedOption.addedCodes;
        this.dataLoaderService.deletedCodes = selectedOption.deletedCodes;
        this.dataLoaderService.updateCodes = selectedOption.updateCodes;
        if (selectedOption.addedCodes.length === 0 && selectedOption.deletedCodes.length === 0) {
          this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
          this.dataLoaderService.flagDictionary.loadingFlag = false;

          this.submitData();
        }

      } else {
        // This code to remove the repeated alternatives.
        let j = 0;
        let boolSuggestion;
        this.tempSuggestionList = selectedOption;
          
        if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1' || this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '3')
          for (let z = 0; z < this.tempSuggestionList.length; z++)
            this.suggestionList.push(this.tempSuggestionList[z]);
        // else
        //   this.suggestionList.push(this.tempSuggestionList);
        // for (let i = 1; i < this.tempSuggestionList.length; i++) {
        //   this.sortingService.sortAlternatives(this.tempSuggestionList[i].addedCodes)
        //   boolSuggestion = this.isSuggestionsEqual(this.tempSuggestionList[i], this.tempSuggestionList[j]);
        //   if (boolSuggestion) {
        //     continue;
        //   }
        //   this.suggestionList.push(this.tempSuggestionList[i]);
        //   j = i;
        // }
      }
      for (let z = 0; z < this.suggestionList.length; z++) {
        if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
          this.sortingService.sortAlternatives(this.suggestionList[z].removedCodes)
        } else {
          this.sortingService.sortAlternatives(this.suggestionList[z].deletedCodes)
        }
        this.sortingService.sortAlternatives(this.suggestionList[z].addedCodes)
      }
    });
    // this.dataLoaderService.flagDictionary.normalSummary = true;
    // this.dataLoaderService.flagDictionary.normalValidSummary = true;
  }

  updatedPrices(){
    //Updated prices from validation response
      for (let s in this.dataLoaderService.gccUpdatedPrices) {
        for (let k in this.dataLoaderService.data.localPackagesList) {
          if ((this.dataLoaderService.data.localPackagesList[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.localPackagesList[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                this.dataLoaderService.data.localPackagesList[k].price = this.dataLoaderService.gccUpdatedPrices[s].price; 
              }
            }
         

          for (let i in this.dataLoaderService.data.upholstery) {
            if ((this.dataLoaderService.data.upholstery[i].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.upholstery[i].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
              this.dataLoaderService.data.upholstery[i].price = this.dataLoaderService.gccUpdatedPrices[s].price;
            }
          }

          for (let i in this.dataLoaderService.data.additionalColor) {
            if ((this.dataLoaderService.data.additionalColor[i].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.additionalColor[i].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                this.dataLoaderService.data.additionalColor[i].price = this.dataLoaderService.gccUpdatedPrices[s].price;
            }
          }

          for (let i in this.dataLoaderService.data.rim) {
            if ((this.dataLoaderService.data.rim[i].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.rim[i].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
              this.dataLoaderService.data.rim[i].price = this.dataLoaderService.gccUpdatedPrices[s].price;
            }
          }

          for (let i in this.dataLoaderService.data.trim) {
            if ((this.dataLoaderService.data.trim[i].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.trim[i].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
             this.dataLoaderService.data.trim[i].price = this.dataLoaderService.gccUpdatedPrices[s].price;
            }
          }

          for (let i in this.dataLoaderService.data.color) {
            if ((this.dataLoaderService.data.color[i].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.color[i].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
              this.dataLoaderService.data.color[i].price = this.dataLoaderService.gccUpdatedPrices[s].price;
            }
          }
          

          for (let i in this.dataLoaderService.data.facOptions) {
            if ((this.dataLoaderService.data.facOptions[i].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.facOptions[i].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
              this.dataLoaderService.data.facOptions[i].price = this.dataLoaderService.gccUpdatedPrices[s].price;
            }
          }

          for (let i in this.dataLoaderService.data.options) {
            if ((this.dataLoaderService.data.options[i].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.options[i].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
              this.dataLoaderService.data.options[i].price = this.dataLoaderService.gccUpdatedPrices[s].price;
            }
          }

          for (let i in this.dataLoaderService.data.packages) {
            if ((this.dataLoaderService.data.packages[i].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.packages[i].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
             this.dataLoaderService.data.packages[i].price = this.dataLoaderService.gccUpdatedPrices[s].price;
            }
          }

          for (let i in this.dataLoaderService.data.stdOpt) {
            if ((this.dataLoaderService.data.stdOpt[i].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.stdOpt[i].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
              this.dataLoaderService.data.stdOpt[i].price = this.dataLoaderService.gccUpdatedPrices[s].price;
            }
          }

        }    
}

amendUpdatedPrices(){
  for (let i in this.dataLoaderService.amendUpdatedPrices) {
    for (let j in this.dataLoaderService.data.color) {
      if ((this.dataLoaderService.data.color[j].code == this.dataLoaderService.amendUpdatedPrices[i].code.substring(0, 3)) && (this.dataLoaderService.data.color[j].codeType == this.dataLoaderService.amendUpdatedPrices[i].codeType)) {
        this.dataLoaderService.data.color[j].price = this.dataLoaderService.amendUpdatedPrices[i].price;
      }
    }
  }

  for (let i in this.dataLoaderService.amendUpdatedPrices) {
    for (let j in this.dataLoaderService.data.additionalColor) {
      if ((this.dataLoaderService.data.additionalColor[j].code == this.dataLoaderService.amendUpdatedPrices[i].code.substring(0, 3)) && (this.dataLoaderService.data.additionalColor[j].codeType == this.dataLoaderService.amendUpdatedPrices[i].codeType)) {
        this.dataLoaderService.data.additionalColor[j].price = this.dataLoaderService.amendUpdatedPrices[i].price;
      }
    }
  }

  for (let i in this.dataLoaderService.amendUpdatedPrices) {
    for (let j in this.dataLoaderService.data.upholstery) {
      if ((this.dataLoaderService.data.upholstery[j].code == this.dataLoaderService.amendUpdatedPrices[i].code.substring(0, 3)) && (this.dataLoaderService.data.upholstery[j].codeType == this.dataLoaderService.amendUpdatedPrices[i].codeType)) {
        this.dataLoaderService.data.upholstery[j].price = this.dataLoaderService.amendUpdatedPrices[i].price;
      }
    }
  }

  for (let i in this.dataLoaderService.amendUpdatedPrices) {
    for (let j in this.dataLoaderService.data.rim) {
      if ((this.dataLoaderService.data.rim[j].code == this.dataLoaderService.amendUpdatedPrices[i].code) && (this.dataLoaderService.data.rim[j].codeType == this.dataLoaderService.amendUpdatedPrices[i].codeType)) {
        this.dataLoaderService.data.rim[j].price = this.dataLoaderService.amendUpdatedPrices[i].price;
      }
    }
  }

  for (let i in this.dataLoaderService.amendUpdatedPrices) {
    for (let j in this.dataLoaderService.data.trim) {
      if ((this.dataLoaderService.data.trim[j].code == this.dataLoaderService.amendUpdatedPrices[i].code && (this.dataLoaderService.data.trim[j].codeType == this.dataLoaderService.amendUpdatedPrices[i].codeType))) {
        this.dataLoaderService.data.trim[j].price = this.dataLoaderService.amendUpdatedPrices[i].price;
      }
    }
  }

  for (let i in this.dataLoaderService.amendUpdatedPrices) {
    for (let j in this.dataLoaderService.data.facOptions) {
      if ((this.dataLoaderService.data.facOptions[j].code == this.dataLoaderService.amendUpdatedPrices[i].code && (this.dataLoaderService.data.facOptions[j].codeType == this.dataLoaderService.amendUpdatedPrices[i].codeType))) {
        this.dataLoaderService.data.facOptions[j].price = this.dataLoaderService.amendUpdatedPrices[i].price;
      }
    }
  }

  for (let i in this.dataLoaderService.amendUpdatedPrices) {
    for (let j in this.dataLoaderService.data.options) {
      if ((this.dataLoaderService.data.options[j].code == this.dataLoaderService.amendUpdatedPrices[i].code && (this.dataLoaderService.data.options[j].codeType == this.dataLoaderService.amendUpdatedPrices[i].codeType))) {
        this.dataLoaderService.data.options[j].price = this.dataLoaderService.amendUpdatedPrices[i].price;
      }
    }
  }
  
  for (let i in this.dataLoaderService.amendUpdatedPrices) {
    for (let j in this.dataLoaderService.data.packages) {
      if ((this.dataLoaderService.data.packages[j].code == this.dataLoaderService.amendUpdatedPrices[i].code && (this.dataLoaderService.data.packages[j].codeType == this.dataLoaderService.amendUpdatedPrices[i].codeType))) {
        this.dataLoaderService.data.packages[j].price = this.dataLoaderService.amendUpdatedPrices[i].price;
      }
    }
  }

  for (let i in this.dataLoaderService.amendUpdatedPrices) {
    for (let j in this.dataLoaderService.data.localPackagesList) {
      if ((this.dataLoaderService.data.localPackagesList[j].code == this.dataLoaderService.amendUpdatedPrices[i].code) && (this.dataLoaderService.data.localPackagesList[j].codeType == this.dataLoaderService.amendUpdatedPrices[i].codeType)) {
        this.dataLoaderService.data.localPackagesList[j].price = this.dataLoaderService.amendUpdatedPrices[i].price;
      }
    }
  }

  for (let i in this.dataLoaderService.amendUpdatedPrices) {
    for (let j in this.dataLoaderService.data.stdOpt) {
      if ((this.dataLoaderService.data.stdOpt[j].code == this.dataLoaderService.amendUpdatedPrices[i].code) && (this.dataLoaderService.data.stdOpt[j].codeType == this.dataLoaderService.amendUpdatedPrices[i].codeType)) {
        this.dataLoaderService.data.stdOpt[j].price = this.dataLoaderService.amendUpdatedPrices[i].price;
      }
    }
  }
}

  isSuggestionsEqual(firstSuggestion, secondSuggestion) {
    if ((firstSuggestion.addedCodes.length !== secondSuggestion.addedCodes.length) &&
      (firstSuggestion.removedCodes.length !== secondSuggestion.removedCodes.length)) {
      return false;
    }
    for (let i = 0; i < firstSuggestion.addedCodes.length; i++) {
      if ((firstSuggestion.addedCodes[i].code !== secondSuggestion.addedCodes[i].code) &&
        (firstSuggestion.addedCodes[i].codeType !== secondSuggestion.addedCodes[i].codeType)) {
        return false;
      }
    }
    for (let i = 0; i < firstSuggestion.removedCodes.length; i++) {
      if ((firstSuggestion.removedCodes[i].code !== secondSuggestion.removedCodes[i].code) &&
        (firstSuggestion.removedCodes[i].codeType !== secondSuggestion.removedCodes[i].codeType)) {
        return false;
      }
    }
    return true;
  }

  getSummaryData() {
    this.subscription = this.commonDataService.getSummary().subscribe(selectedOption => {
      this.addedCodes = selectedOption.addedCodes;
      this.addedMsgs = selectedOption.addedMsgs;
      this.deletedCodes = selectedOption.deletedCodes;
      this.deletedMsgs = selectedOption.deletedMsgs;
    });
  }

  /**
   * To select a particular package option
   * @param index
   * @returns none
   */
  selectItem(index) {
    this.selectedIndex = index;
  }

  /**
  * To close the alternate options popup
  * @param index
  * @returns none
  */
  // function to undo item in alternate popup
  undoItems(){
    // for color
    let undoColor:any;
    for (let i in this.colorOptions) {
			if (this.colorOptions[i].code === this.dataLoaderService.previousColorExp) {
          undoColor = this.colorOptions[i];
          this.colorOptions[i].selected = true;
      }
      else{
        this.colorOptions[i].selected = false;
      }
    }
    this.priceCalculationService.notifyExpertCompForLastItem({ fromComponent: "expertColor", data: [undoColor]});
    
    // for Additional color
    let undoAddColor:any;
    for (let i in this.addColorOptions) {
			if (this.addColorOptions[i].code === this.dataLoaderService.previousAddColorExp) {
        undoAddColor = this.addColorOptions[i];
          this.addColorOptions[i].selected = true;
      }
      else{
        this.addColorOptions[i].selected = false;
      }
    }
    this.priceCalculationService.notifyExpertCompForLastItem({ fromComponent: "expertAddColor", data: [undoAddColor]});

    // for Upholstery
    let undoUpholstery:any;
    for (let i in this.upholstery) {
			if (this.upholstery[i].code === this.dataLoaderService.previousUpholsteryExp) {
        undoUpholstery = this.upholstery[i];
          this.upholstery[i].selected = true;
      }
      else{
        this.upholstery[i].selected = false;
      }
    }
    this.priceCalculationService.notifyExpertCompForLastItem({ fromComponent: "expertUpholstery", data: [undoUpholstery]});
    // for Rim
    let undoRim:any;
    for (let i in this.rim) {
			if (this.rim[i].code === this.dataLoaderService.previousRimExp) {
        undoRim = this.rim[i];
          this.rim[i].selected = true;
      }
      else{
        this.rim[i].selected = false;
      }
    }
    this.priceCalculationService.notifyExpertCompForLastItem({ fromComponent: "expertRim", data: [undoRim]});
    
    // for Trim
    let undoTrim:any;
    for (let i in this.trim) {
			if (this.trim[i].code === this.dataLoaderService.previousTrimExp) {
        undoTrim = this.trim[i];
          this.trim[i].selected = true;
      }
      else{
        this.trim[i].selected = false;
      }
    }
    this.priceCalculationService.notifyExpertCompForLastItem({ fromComponent: "expertTrim", data: [undoTrim]});

    // for Factory Options
    let undoFactory:Data[]=[];
    for (let i in this.factoryOptions) {
      if(this.dataLoaderService.previousFactoryExp.length>0){
        for (let j in this.dataLoaderService.previousFactoryExp) {
          if (this.factoryOptions[i].code === this.dataLoaderService.previousFactoryExp[j]) {
            undoFactory.push(this.factoryOptions[i]);
              this.factoryOptions[i].selected = true;
              break;
          }
            else{
              this.factoryOptions[i].selected = false;
            }
        }
      }
      else{
        this.factoryOptions[i].selected = false;
      }
    }
    this.priceCalculationService.notifyExpertCompForLastItem({ fromComponent: "expertFactory", data: [undoFactory]});
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [undoFactory] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [undoFactory] });

    // for Local Options
    let undoLocal:Data[]=[];
    for (let i in this.localOptions) {
      if(this.dataLoaderService.previousLocalExp.length>0){
        for (let j in this.dataLoaderService.previousLocalExp) {
          if (this.localOptions[i].code === this.dataLoaderService.previousLocalExp[j]) {
            undoLocal.push(this.localOptions[i]);
              this.localOptions[i].selected = true;
              break;
          }
            else{
              this.localOptions[i].selected = false;
            }
        }
      }
      else{
        this.localOptions[i].selected = false;
      }
    }
    this.priceCalculationService.notifyExpertCompForLastItem({ fromComponent: "expertLocal", data: [undoLocal]});
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [undoLocal] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "expertLocal", data: [undoLocal] });

    // for Package Options
    let undoPackages:Data[]=[];
    for (let i in this.packageOptions) {
      if(this.dataLoaderService.previousPackagesExp.length>0){
        for (let j in this.dataLoaderService.previousPackagesExp) {
          if (this.packageOptions[i].code === this.dataLoaderService.previousPackagesExp[j]) {
            undoPackages.push(this.packageOptions[i]);
              this.packageOptions[i].selected = true;
              break;
          }
            else{
              this.packageOptions[i].selected = false;
            }
        }
      }
      else{
        this.packageOptions[i].selected = false;
      }
    }
    this.priceCalculationService.notifyExpertCompForLastItem({ fromComponent: "expertPackage", data: [undoPackages]});
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [undoPackages] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "expertPackage", data: [undoPackages] });
    
    // for LocalPackage Options
    let undoLocalPackages:Data[]=[];
    for (let i in this.localPackageOptions) {
      if(this.dataLoaderService.previousLocalPackagesExp.length>0){
        for (let j in this.dataLoaderService.previousLocalPackagesExp) {
          if (this.localPackageOptions[i].code === this.dataLoaderService.previousLocalPackagesExp[j]) {
            undoLocalPackages.push(this.localPackageOptions[i]);
              this.localPackageOptions[i].selected = true;
              break;
          }
            else{
              this.localPackageOptions[i].selected = false;
            }
        }
      }
      else{
        this.localPackageOptions[i].selected = false;
      }
    }
    this.priceCalculationService.notifyExpertCompForLastItem({ fromComponent: "expertLocalPackage", data: [undoLocalPackages]});
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [undoLocalPackages] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "expertLocalPackage", data: [undoLocalPackages] });
  }
  // undo flag reset 
  undoFlagReset(){
    this.dataLoaderService.flagDictionary.undoActivated=false;//Helpful for expert mode undo for 2nd and above times
    this.dataLoaderService.flagDictionary.undoActivatedForColor= false;
    this.dataLoaderService.flagDictionary.undoActivatedForAddColor= false;
    this.dataLoaderService.flagDictionary.undoActivatedForUpholstery= false;
    this.dataLoaderService.flagDictionary.undoActivatedForRim= false;
    this.dataLoaderService.flagDictionary.undoActivatedForTrim= false;
    this.dataLoaderService.flagDictionary.undoActivatedForFactory= false;
    this.dataLoaderService.flagDictionary.undoActivatedForLocal= false;
    this.dataLoaderService.flagDictionary.undoActivatedForLocalPackages= false;
    this.dataLoaderService.flagDictionary.undoActivatedForPackages= false;
  }
  closePopup() {

    // On cancel update the configuration ID
    this.alternateOptionsService.configurationId = this.dataLoaderService.intialConfigurationId

    // accept button fix
    this.showAcceptMandatory = true;

    if (this.dataLoaderService.vehicleInfo.urlFlag == '2' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
      this.dataLoaderService.hiddenOptions = this.summaryValidationService.ppmPreviousHiddenOptions;
      this.dataLoaderService.internalCodes = this.dataLoaderService.ppmInitialInternalOptions;
      this.dataLoaderService.amendInternalCodes = this.dataLoaderService.ppmInitialInternalOptions;
    }
    // reset added and removed codes array -start
    this.dataLoaderService.expAdd.splice(0,this.dataLoaderService.expAdd.length);
    this.dataLoaderService.expertRemovedCodes.splice(0,this.dataLoaderService.expertRemovedCodes.length);
    this.dataLoaderService.expertAddedCodes.splice(0,this.dataLoaderService.expertAddedCodes.length);
    // end
    if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
      this.dataLoaderService.hiddenOptions = this.dataLoaderService.gccPreviousHiddenOptions;
    }

    this.dataLoaderService.expAddedOnClose = this.dataLoaderService.expertAddedCodes;
    this.dataLoaderService.expRemovedOnClose = this.dataLoaderService.expertRemovedCodes;

    this.dataLoaderService.expertRemovedCodes = [];
    this.dataLoaderService.flagDictionary.summaryValidate = false;
    this.dataLoaderService.flagDictionary.migrationFlag = false;
    this.dataLoaderService.flagDictionary.openExpertValidateFlag = false;
    this.dataLoaderService.flagDictionary.expertValidateFlag = true;
    this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
    this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
    this.dataLoaderService.flagDictionary.confirmValidateFlag = false;
    this.progressBarService.progressBarValidation();
    this.dataLoaderService.flagDictionary.closeFlag = true;
    // for undo items
    if(this.dataLoaderService.flagDictionary.undoActivated){
      this.undoItems();
    }
    this.undoFlagReset();
    
  }

  undoValidate() {
    this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
    this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
  }

  openSuccessMsg() {

    console.log("this.dataLoaderService.addedCodes", this.dataLoaderService.addedCodes);
    console.log("this.dataLoaderService.deletedCodes", this.dataLoaderService.deletedCodes);
const addedCodes = this.dataLoaderService.addedCodes || [];
const deletedCodes = this.dataLoaderService.deletedCodes || [];
if (addedCodes.length > 0 && deletedCodes.length > 0) {
    this.dataLoaderService.addedCodes = this.dataLoaderService.addedCodes.filter(added => {
  const matchIndex = this.dataLoaderService.deletedCodes.findIndex(deleted =>
    deleted.code === added.code &&
    deleted.codeType === added.codeType &&
    deleted.description === added.description
  );
  if (matchIndex !== -1) {
    this.dataLoaderService.deletedCodes.splice(matchIndex, 1);
    return false;
  }

  return true; 
});
}

    this.amendUpdatedPrices();
    this.removeCodesOnValidate(this.dataLoaderService.deletedCodes);
    this.progressBarService.progressBarValidation();

    if (!this.dataLoaderService.flagDictionary.summaryValidate && !this.dataLoaderService.flagDictionary.confirmValidateFlag) {
      this.dataLoaderService.flagDictionary.expertvalidated = false;
      this.dataLoaderService.flagDictionary.expertSummaryFlag = false;
      this.dataLoaderService.flagDictionary.expertFlag = false;
    }
    else if (this.dataLoaderService.flagDictionary.summaryValidate) {
      this.dataLoaderService.flagDictionary.summaryValidate = false;
      this.dataLoaderService.flagDictionary.expertvalidated = false;
      this.dataLoaderService.flagDictionary.expertFlag = false;
      this.dataLoaderService.flagDictionary.expertSummaryFlag = true;
    }

    else if (this.dataLoaderService.flagDictionary.confirmValidateFlag) {
      this.dataLoaderService.flagDictionary.expertvalidated = false;
      this.dataLoaderService.flagDictionary.expertSummaryFlag = false;
      this.dataLoaderService.flagDictionary.expertFlag = true;
      this.dataLoaderService.flagDictionary.confirmValidateFlag = false;
    }
    this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
    this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
    this.dataLoaderService.flagDictionary.expertValidateFlag = false;
    this.dataLoaderService.flagDictionary.validated = true;
    this.dataLoaderService.flagDictionary.expertvalidated = true;
    this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;


    this.sortingService.sortCodes(this.colorOptions, true)
    this.sortingService.sortCodes(this.addColorOptions, true)
    this.sortingService.sortCodes(this.rim, true)
    this.sortingService.sortCodes(this.upholstery, true)
    this.sortingService.sortCodes(this.trim, true)
    this.sortingService.sortCodes(this.factoryOptions, true)
    this.sortingService.sortCodes(this.localOptions, true)
    this.sortingService.sortCodes(this.standardOptions, true)
    this.sortingService.sortCodes(this.packageOptions, true)
    this.sortingService.sortCodes(this.localPackageOptions, true)
    this.commonDataService.notifyAllPackageOptionsItem(this.localPackageOptions.concat(this.packageOptions))
    for(let i in this.colorOptions){
      for(let j in this.upholstery){
      if(this.colorOptions[i].selected == true && this.upholstery[j].selected == true){
        this.commonDataService.progressBarColorFlag = true;
        break;
      }
    }
    
    }
    if (this.commonDataService.progressBarColorFlag == true) {
      setTimeout(() => {
        this.progressBarService.illuminateGreen();
        this.commonDataService.progressBarColorFlag = false;

      }, 0);
    }
    else {
      setTimeout(() => {
        this.progressBarService.illuminateRed();
        this.commonDataService.progressBarColorFlag = false;
      }, 0);
    }
    // undo flag reset - as we dont use it amendment
    this.undoFlagReset();
  }

  changeIcon() {
    if (this.icon == "gray") {
      this.icon = "blue";
    }
    else {
      this.icon = "gray";
    }
    this.dataLoaderService.flagDictionary.summaryValidate = false;
    this.dataLoaderService.flagDictionary.migrationFlag = false;
    this.dataLoaderService.flagDictionary.openExpertValidateFlag = false;
    this.dataLoaderService.flagDictionary.expertValidateFlag = true;
    this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
    this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
    this.dataLoaderService.flagDictionary.confirmValidateFlag = false;
    setTimeout(() => {
      this.progressBarService.illuminateRed();
      this.commonDataService.progressBarColorFlag = false;
    }, 0);
  }

  submitData() {
    let configData = this.summaryService.submitData();
    (<HTMLInputElement>document.getElementById('acceptString')).value = configData + '';
    (<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
    (<HTMLFormElement>document.getElementById('form1')).submit();
  }

  /**
  * To make the selected item's selection true
  * @param index
  * @returns none
  */
  selectedCode(item, index) {
    for (let i in this.suggestionList) {
      if (this.suggestionList[i].selected === true && this.suggestionList[i].selected != undefined) {
        this.suggestionList[i].selected = false;
      }
    }
    // Index of configuration Id of selected suggestion
    this.configurationIdIndex = index
    this.selectCode = item;
    this.selectCode.selected = true;
    this.showAcceptMandatory = true;
  }
  async getlatestPriceForGcc(){
    return new Promise<any>((resolve, reject) => {
    let suggestionLists: any;
      let returnSuggestionValues = this.alternateOptionsService.getUpdatedPriceForAlternates(this.selectCode,this.configurationIdIndex);
      returnSuggestionValues.subscribe(
        updatedPriceData => {
          suggestionLists = updatedPriceData.suggestions[0];
          this.dataLoaderService.gccUpdatedPrices= updatedPriceData.suggestions[0].updatedPrices;
          //updating price for every components
          for(let comp in this.dataLoaderService.data){
            if(Array.isArray(this.dataLoaderService.data[comp]) && 
            this.dataLoaderService.data[comp].length>0 && 
            this.dataLoaderService.data[comp].some((item) => item.hasOwnProperty('code'))){
              this.dataLoaderService.data[comp].map((obj) => {
                let result = this.dataLoaderService.gccUpdatedPrices.filter(updatedPriceItem =>{
                  return (updatedPriceItem.code == obj.code && updatedPriceItem.codeType == obj.codeType)
                });
                if(result.length > 0){
                  obj.price = result[0].price;
                }
                return obj;
              });
            }
          }
        resolve(true)
      });
    }).catch(()=>{
    })
  }
  suggestionCodes(){
    if (Array.isArray(this.alternateOptionsService.configurationId)) {
      //update configuration ID after accept alternative
      this.dataLoaderService.intialConfigurationId = this.alternateOptionsService.configurationId[this.configurationIdIndex]
      // set configurationId for new/analysis after accept suggestion
      this.alternateOptionsService.configurationId = this.alternateOptionsService.configurationId[this.configurationIdIndex]
    }
    else {
      this.dataLoaderService.intialConfigurationId = this.alternateOptionsService.configurationId
      this.alternateOptionsService.configurationId = this.alternateOptionsService.configurationId
    }
    // console.log("accept")
    this.alternateOptionsService.intialExpertColor = this.alternateOptionsService.addedColor
    if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
      this.getlatestPriceForGcc().then(()=>{
        this.suggestionCodesImplementation();
      })
    }
    else {
      this.suggestionCodesImplementation();
    }
    // Undo flag reset
    this.undoFlagReset();
  }
  suggestionCodesImplementation() {
    
    this.showAcceptMandatory = true;
    this.alternateFactory = [];
    this.alternateLocal = [];
    this.alternatePackage = [];
    this.alternateLocalPackage = [];
    this.alternateStandard = [];

    

    //this.dataLoaderService.flagDictionary.expertFlag = true;
    for (let k in this.factoryOptions) {
      if (this.factoryOptions[k].selected) {
        this.alternateFactory.push(this.factoryOptions[k]);
      }
    }
    this.alternateFactory = _.uniqBy(this.alternateFactory, function (o) {
      return o.code;
    });
    for (let k in this.localOptions) {
      if (this.localOptions[k].selected) {
        this.alternateLocal.push(this.localOptions[k]);
      }
    }
    this.alternateLocal = _.uniqBy(this.alternateLocal, function (o) {
      return o.code;
    });

    for (let k in this.packageOptions) {
      if (this.packageOptions[k].selected) {
        this.alternatePackage.push(this.packageOptions[k]);
      }
    }
    this.alternatePackage = _.uniqBy(this.alternatePackage, function (o) {
      return o.code;
    });
    for (let k in this.localPackageOptions) {
      if (this.localPackageOptions[k].selected) {
        this.alternateLocalPackage.push(this.localPackageOptions[k]);
      }
    }
    this.alternateLocalPackage = _.uniqBy(this.alternateLocalPackage, function (o) {
      return o.code;
    });

    for (let k in this.standardOptions) {
      if (this.standardOptions[k].selected) {
        this.alternateStandard.push(this.standardOptions[k]);
      }
    }
    this.alternateStandard = _.uniqBy(this.alternateStandard, function (o) {
      return o.code;
    });

    if (this.selectCode != undefined) {
      // updating latest hiddenCodes for GCC
      if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
        this.dataLoaderService.hiddenOptions = this.selectCode.hiddenOptionsCodes;
      }
      this.removeCodes();
      if (!this.dataLoaderService.flagDictionary.summaryValidate && !this.dataLoaderService.flagDictionary.confirmValidateFlag) {
        this.dataLoaderService.flagDictionary.expertValidateFlag = false;
        this.dataLoaderService.flagDictionary.expertSummaryFlag = false;
        this.dataLoaderService.flagDictionary.expertFlag = false;
      }
      else if (this.dataLoaderService.flagDictionary.summaryValidate) {
        this.dataLoaderService.flagDictionary.summaryValidate = false;
        this.dataLoaderService.flagDictionary.expertValidateFlag = false;
        this.dataLoaderService.flagDictionary.expertFlag = false;
        this.dataLoaderService.flagDictionary.expertSummaryFlag = true;
      }

      else if (this.dataLoaderService.flagDictionary.confirmValidateFlag) {
        this.dataLoaderService.flagDictionary.expertValidateFlag = false;
        this.dataLoaderService.flagDictionary.expertSummaryFlag = false;
        if (this.dataLoaderService.flagDictionary.testFlag) {
          this.dataLoaderService.flagDictionary.expertFlag = true;
        }
        this.dataLoaderService.flagDictionary.confirmValidateFlag = false;
      }
      this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
      this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
      this.dataLoaderService.flagDictionary.expertValidateFlag = false;
    } else {
      this.showAcceptMandatory = false;
      this.dataLoaderService.flagDictionary.expertFlag = false;
      this.dataLoaderService.flagDictionary.expertSummaryFlag = false;
      this.dataLoaderService.flagDictionary.openExpertValidateFlag = true;
    }
    // this.progressBarService.progressBarValidation();

    this.sortingService.sortCodes(this.colorOptions, true)
    this.sortingService.sortCodes(this.addColorOptions, true)
    this.sortingService.sortCodes(this.rim, true)
    this.sortingService.sortCodes(this.upholstery, true)
    this.sortingService.sortCodes(this.trim, true)
    this.sortingService.sortCodes(this.factoryOptions, true)
    this.sortingService.sortCodes(this.localOptions, true)
    this.sortingService.sortCodes(this.standardOptions, true)
    this.sortingService.sortCodes(this.packageOptions, true)
    this.sortingService.sortCodes(this.localPackageOptions, true)
    for (let i in this.colorOptions) {
      for (let j in this.upholstery) {
        if (this.colorOptions[i].selected == true && this.upholstery[j].selected == true) {
          this.commonDataService.progressBarColorFlag = true;
          break;
        }
      }
    }
    if (this.commonDataService.progressBarColorFlag == true) {
      setTimeout(() => {
        this.progressBarService.illuminateGreen();
        this.commonDataService.progressBarColorFlag = false;

      }, 0);
    }
    if(this.commonDataService.progressBarColorFlag == true){
    setTimeout(() => {
      this.progressBarService.illuminateGreen();
      this.commonDataService.progressBarColorFlag = false;
       
    }, 0);
  }
  else{
    setTimeout(() => {
      this.progressBarService.illuminateRed();
      this.commonDataService.progressBarColorFlag = false;
    }, 0);
  }
}


  removeCodes() {

    //Color options
    for (let j in this.selectCode.removedCodes) {
      for (let k in this.colorOptions) {
        if ((this.selectCode.removedCodes[j].code === this.colorOptions[k].code) && (this.selectCode.removedCodes[j].codeType === this.colorOptions[k].codeType)) {
          this.colorOptions[k].selected = false;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
              if ((this.colorOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.colorOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.colorOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
              }
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertColor", data: [] });
          }
        }
      }

    //Additional Color options
    if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.addColorOptions.length > 0) {
      for (let j in this.selectCode.removedCodes) {
        for (let k in this.addColorOptions) {
          if ((this.selectCode.removedCodes[j].code === this.addColorOptions[k].code) && (this.selectCode.removedCodes[j].codeType === this.addColorOptions[k].codeType)) {
            this.addColorOptions[k].selected = false;
            //Updated Prices from validation response
              for (let s in this.dataLoaderService.gccUpdatedPrices) {
                  if ((this.addColorOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.addColorOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                    this.addColorOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                  }
                }
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: [] });
          }
        }
      }
    }

    //Trim options
    for (let j in this.selectCode.removedCodes) {
      for (let k in this.trim) {
        if ((this.selectCode.removedCodes[j].code === this.trim[k].code) && (this.selectCode.removedCodes[j].codeType === this.trim[k].codeType)) {
          this.trim[k].selected = false;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
              if ((this.trim[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.trim[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                this.trim[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
              }
            }
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertTrim", data: [] });
        }
      }
    }

    //Rim options
    for (let j in this.selectCode.removedCodes) {
      for (let k in this.rim) {
        if ((this.selectCode.removedCodes[j].code === this.rim[k].code) && (this.selectCode.removedCodes[j].codeType === this.rim[k].codeType)) {
          this.rim[k].selected = false;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.rim[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.rim[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.rim[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
              }
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertRim", data: [] });
          }
        }
      }

    //Upholstery options
    for (let j in this.selectCode.removedCodes) {
      for (let k in this.upholstery) {
        if ((this.selectCode.removedCodes[j].code === this.upholstery[k].code) && (this.selectCode.removedCodes[j].codeType === this.upholstery[k].codeType)) {
          this.upholstery[k].selected = false;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.upholstery[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.upholstery[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.upholstery[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: [] });
        }
      }
    }

    //Factory options
    for (let j in this.selectCode.removedCodes) {
      for (let k in this.factoryOptions) {
        if ((this.selectCode.removedCodes[j].code === this.factoryOptions[k].code) && (this.selectCode.removedCodes[j].codeType === this.factoryOptions[k].codeType)) {
          this.factoryOptions[k].selected = false;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.factoryOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.factoryOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.factoryOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
              }
            for (let z in this.alternateFactory) {
              if (this.alternateFactory[z].code == this.factoryOptions[k].code)
                this.alternateFactory.splice(Number(z), 1);
            }
          }
        }
      }
      this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.alternateFactory] });
      this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.alternateFactory] });

    //Local Options
    for (let j in this.selectCode.removedCodes) {
      for (let k in this.localOptions) {
        if ((this.selectCode.removedCodes[j].code === this.localOptions[k].code) && (this.selectCode.removedCodes[j].codeType === this.localOptions[k].codeType)) {
          this.localOptions[k].selected = false;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.localOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.localOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.localOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
              }
            for (let z in this.alternateLocal) {
              if (this.alternateLocal[z].code == this.localOptions[k].code)
                this.alternateLocal.splice(Number(z), 1);
            }
          }
        }
      }
      this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.alternateLocal] });
      this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.alternateLocal] });

    // Package Options
    for (let j in this.selectCode.removedCodes) {
      for (let k in this.packageOptions) {
        if ((this.selectCode.removedCodes[j].code === this.packageOptions[k].code) && (this.selectCode.removedCodes[j].codeType === this.packageOptions[k].codeType)) {
          this.packageOptions[k].selected = false;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.packageOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.packageOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.packageOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
              }
            for (let z in this.alternatePackage) {
              if (this.alternatePackage[z].code == this.packageOptions[k].code)
                this.alternatePackage.splice(Number(z), 1);
            }
          }
        }
      }
      this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.alternatePackage] });
      this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.alternatePackage] });

    //Local Package options
    for (let j in this.selectCode.removedCodes) {
      for (let k in this.localPackageOptions) {
        if ((this.selectCode.removedCodes[j].code === this.localPackageOptions[k].code) && (this.selectCode.removedCodes[j].codeType === this.localPackageOptions[k].codeType)) {
          this.localPackageOptions[k].selected = false;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.localPackageOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.localPackageOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codetype)) {
                  this.localPackageOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
              }
            for (let z in this.alternateLocalPackage) {
              if (this.alternateLocalPackage[z].code == this.localPackageOptions[k].code)
                this.alternateLocalPackage.splice(Number(z), 1);
            }
          }
        }
      }
      this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.alternateLocalPackage] });
      this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.alternateLocalPackage] });

    //Standard Options
    for (let j in this.selectCode.removedCodes) {
      for (let k in this.standardOptions) {
        if ((this.selectCode.removedCodes[j].code === this.standardOptions[k].code) && (this.selectCode.removedCodes[j].codeType === this.standardOptions[k].codeType)) {
          this.standardOptions[k].selected = false;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
              if ((this.standardOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.standardOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.standardOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
              }
          for (let z in this.alternateStandard) {
            if (this.alternateStandard[z].code == this.standardOptions[k].code)
              this.alternateStandard.splice(Number(z), 1);
          }
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.alternateStandard] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertStandard", data: [this.alternateStandard] });

    this.addCodes();
  }

  addCodes() {

    let addedColor: String
    //Additional Color options:
    if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.addColorOptions.length > 0) {
      for (let j in this.selectCode.addedCodes) {
        for (let k in this.addColorOptions) {
          if ((this.selectCode.addedCodes[j].code === this.addColorOptions[k].code) && (this.selectCode.addedCodes[j].codeType === this.addColorOptions[k].codeType)
          && (this.selectCode.addedCodes[j].code == (this.dataLoaderService.selectedAddColor && this.dataLoaderService.selectedAddColor.code ? this.dataLoaderService.selectedAddColor.code : ''))) {
            this.addColorOptions.forEach(element => {
              element.selected = false;
            });
            addedColor = this.dataLoaderService.selectedAddColor.code;
            this.addColorOptions[k].selected = true;

            //Updated Prices from validation response
              for (let s in this.dataLoaderService.gccUpdatedPrices) {
                  if ((this.addColorOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.addColorOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                    this.addColorOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                  }
              }
            this.dataLoaderService.previousExpertAddColor = [this.addColorOptions[k]];
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [this.addColorOptions[k]] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: [this.addColorOptions[k]] });
          }
        }
      }
    }

    //Color options:    

    for (let j in this.selectCode.addedCodes) {
      for (let k in this.colorOptions) {
        if ((this.selectCode.addedCodes[j].code === this.colorOptions[k].code) && (this.selectCode.addedCodes[j].codeType === this.colorOptions[k].codeType)
          && (this.selectCode.addedCodes[j].code != addedColor)) {
          this.colorOptions.forEach(element => {
            element.selected = false;
          });
          this.colorOptions[k].selected = true;

          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.colorOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.colorOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.colorOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.dataLoaderService.previousExpertColor = [this.colorOptions[k]];
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [this.colorOptions[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertColor", data: [this.colorOptions[k]] });
        }
      }
    }

    //Rim options:    
    for (let j in this.selectCode.addedCodes) {
      for (let k in this.rim) {
        if ((this.selectCode.addedCodes[j].code === this.rim[k].code) && (this.selectCode.addedCodes[j].codeType === this.rim[k].codeType)) {
          this.rim.forEach(element => {
            element.selected = false;
          });
          this.rim[k].selected = true;

          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.rim[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.rim[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.rim[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.dataLoaderService.previousExpertRim = [this.rim[k]];
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [this.rim[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertRim", data: [this.rim[k]] });
        }
      }
    }

    //Upholstery options:    
    for (let j in this.selectCode.addedCodes) {
      for (let k in this.upholstery) {
        if ((this.selectCode.addedCodes[j].code === this.upholstery[k].code) && (this.selectCode.addedCodes[j].codeType === this.upholstery[k].codeType)) {
          this.upholstery.forEach(element => {
            element.selected = false;
          });
          this.upholstery[k].selected = true;

          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.upholstery[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.upholstery[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.upholstery[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.dataLoaderService.previousExpertUpholstery = [this.upholstery[k]];
          this.commonDataService.progressBarNewOrderUpholsteryFlag = true;
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [this.upholstery[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: [this.upholstery[k]] });
        }
      }
    }

    //Trim options:
    for (let j in this.selectCode.addedCodes) {
      for (let k in this.trim) {
        if ((this.selectCode.addedCodes[j].code === this.trim[k].code) && (this.selectCode.addedCodes[j].codeType === this.trim[k].codeType)) {
          this.trim.forEach(element => {
            element.selected = false;
          });
          this.trim[k].selected = true;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.trim[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.trim[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.trim[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [this.trim[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertTrim", data: [this.trim[k]] });
        }
      }
    }

    //Factory options

    for (let j in this.selectCode.addedCodes) {
      for (let k in this.factoryOptions) {
        if ((this.selectCode.addedCodes[j].code === this.factoryOptions[k].code) && (this.selectCode.addedCodes[j].codeType === this.factoryOptions[k].codeType)) {
          this.factoryOptions[k].selected = true;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.factoryOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.factoryOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.factoryOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.alternateFactory.push(this.factoryOptions[k]);
          this.alternateFactory = _.uniqBy(this.alternateFactory, function (o) {
            return o.code;
          });
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.alternateFactory] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.alternateFactory] });


    // Local Options

    for (let j in this.selectCode.addedCodes) {
      for (let k in this.localOptions) {
        if ((this.selectCode.addedCodes[j].code === this.localOptions[k].code) && (this.selectCode.addedCodes[j].codeType === this.localOptions[k].codeType)) {
          this.localOptions[k].selected = true;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.localOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.localOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.localOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.alternateLocal.push(this.localOptions[k]);
          this.alternateLocal = _.uniqBy(this.alternateLocal, function (o) {
            return o.code;
          });
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.alternateLocal] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.alternateLocal] });

    // Package options
    for (let j in this.selectCode.addedCodes) {
      for (let k in this.packageOptions) {
        if ((this.selectCode.addedCodes[j].code === this.packageOptions[k].code) && (this.selectCode.addedCodes[j].codeType === this.packageOptions[k].codeType)) {
          this.packageOptions[k].selected = true;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.packageOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.packageOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.packageOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.alternatePackage.push(this.packageOptions[k]);
          this.alternatePackage = _.uniqBy(this.alternatePackage, function (o) {
            return o.code;
          });
          this.checkAddEquipmentsInPackage(this.alternatePackage);
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.alternatePackage] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.alternatePackage] });

    //Local Package options
    for (let j in this.selectCode.addedCodes) {
      for (let k in this.localPackageOptions) {
        if ((this.selectCode.addedCodes[j].code === this.localPackageOptions[k].code) && (this.selectCode.addedCodes[j].codeType === this.localPackageOptions[k].codeType)) {
          this.localPackageOptions[k].selected = true;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.localPackageOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.localPackageOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.localPackageOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.alternateLocalPackage.push(this.localPackageOptions[k]);
          this.alternateLocalPackage = _.uniqBy(this.alternateLocalPackage, function (o) {
            return o.code;
          });
          this.checkAddEquipmentsInPackage(this.alternateLocalPackage);
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.alternateLocalPackage] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.alternateLocalPackage] });

    //Standard options

    for (let j in this.selectCode.addedCodes) {
      for (let k in this.standardOptions) {
        if ((this.selectCode.addedCodes[j].code === this.standardOptions[k].code) && (this.selectCode.addedCodes[j].codeType === this.standardOptions[k].codeType)) {
          this.standardOptions[k].selected = true;
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.standardOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.standardOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  
                    this.standardOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.alternateStandard.push(this.standardOptions[k]);
          this.alternateStandard = _.uniqBy(this.alternateStandard, function (o) {
            return o.code;
          });
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.alternateStandard] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertStandard", data: [this.alternateStandard] });

    this.priceCalculationService.expertModePriceCalculation();

    //Updated Prices from validation response
    this.updatedCodesAlternatives();
    // this.priceCalculationService.normalModePriceCalculation();
    this.selectCode = undefined;

    this.sortingService.sortCodes(this.factoryOptions, true)
    this.sortingService.sortCodes(this.colorOptions, true)
    this.sortingService.sortCodes(this.addColorOptions, true)
    this.sortingService.sortCodes(this.rim, true)
    this.sortingService.sortCodes(this.upholstery, true)
    this.sortingService.sortCodes(this.trim, true)
    this.sortingService.sortCodes(this.localOptions, true)
    this.sortingService.sortCodes(this.standardOptions, true)
    this.sortingService.sortCodes(this.packageOptions, true)
    this.sortingService.sortCodes(this.localPackageOptions, true)
    // For all package options
    this.commonDataService.notifyAllPackageOptionsItem(this.localPackageOptions.concat(this.packageOptions))
  }

 
  
  updatedCodesAlternatives() {
    let updatedColor: String

    //Additional Color options:
    if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.addColorOptions.length > 0) {
      for (let j in this.selectCode.updatedCodes) {
        for (let k in this.addColorOptions) {
          if ((this.selectCode.updatedCodes[j].code === this.addColorOptions[k].code) && (this.selectCode.updatedCodes[j].codeType === this.addColorOptions[k].codeType)
            && (this.selectCode.updatedCodes[j].code == this.dataLoaderService.selectedAddColor.code)) {
            //Updated Prices from validation response
              for (let s in this.dataLoaderService.gccUpdatedPrices) {
                  if ((this.addColorOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.addColorOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                    this.addColorOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                  }
            }
            this.dataLoaderService.previousExpertAddColor = [this.addColorOptions[k]];
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [this.addColorOptions[k]] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: [this.addColorOptions[k]] });
          }
        }
      }
    }

    //Color options:    

    for (let j in this.selectCode.updatedCodes) {
      for (let k in this.colorOptions) {
        if ((this.selectCode.updatedCodes[j].code === this.colorOptions[k].code) && (this.selectCode.updatedCodes[j].codeType === this.colorOptions[k].codeType)
          && (this.selectCode.updatedCodes[j].code != updatedColor)) {
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.colorOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.colorOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                   this.colorOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
          }
          this.dataLoaderService.previousExpertColor = [this.colorOptions[k]];
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [this.colorOptions[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertColor", data: [this.colorOptions[k]] });
        }
      }
    }

    //Rim options:    
    for (let j in this.selectCode.updatedCodes) {
      for (let k in this.rim) {
        if ((this.selectCode.updatedCodes[j].code === this.rim[k].code) && (this.selectCode.updatedCodes[j].codeType === this.rim[k].codeType)) {
         //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.rim[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.rim[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.rim[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
          }
          this.dataLoaderService.previousExpertRim = [this.rim[k]];
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [this.rim[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertRim", data: [this.rim[k]] });
        }
      }
    }

    //Upholstery options:    
    for (let j in this.selectCode.updatedCodes) {
      for (let k in this.upholstery) {
        if ((this.selectCode.updatedCodes[j].code === this.upholstery[k].code) && (this.selectCode.updatedCodes[j].codeType === this.upholstery[k].codeType)) {

          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
              // for (let c in this.dataLoaderService.gccUpdatedPrices[s]) {
                if ((this.upholstery[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.upholstery[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.upholstery[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
         
          this.dataLoaderService.previousExpertUpholstery = [this.upholstery[k]];
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [this.upholstery[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: [this.upholstery[k]] });
        }
      }
    }

    //Trim options:
    for (let j in this.selectCode.updatedCodes) {
      for (let k in this.trim) {
        if ((this.selectCode.updatedCodes[j].code === this.trim[k].code) && (this.selectCode.updatedCodes[j].codeType === this.trim[k].codeType)) {
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.trim[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.trim[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.trim[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [this.trim[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertTrim", data: [this.trim[k]] });
        }
      }
    }

    //Factory options

    for (let j in this.selectCode.updatedCodes) {
      for (let k in this.factoryOptions) {
        if ((this.selectCode.updatedCodes[j].code === this.factoryOptions[k].code) && (this.selectCode.updatedCodes[j].codeType === this.factoryOptions[k].codeType)) {
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
              // for (let c in this.dataLoaderService.gccUpdatedPrices[s]) {
                if ((this.factoryOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.factoryOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.factoryOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          this.alternateFactory.push(this.factoryOptions[k]);
          this.alternateFactory = _.uniqBy(this.alternateFactory, function (o) {
            return o.code;
          });
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.alternateFactory] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.alternateFactory] });


    // Local Options

    for (let j in this.selectCode.updatedCodes) {
      for (let k in this.localOptions) {
        if ((this.selectCode.updatedCodes[j].code === this.localOptions[k].code) && (this.selectCode.updatedCodes[j].codeType === this.localOptions[k].codeType)) {
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.localOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.localOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.localOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          
          this.alternateLocal.push(this.localOptions[k]);
          this.alternateLocal = _.uniqBy(this.alternateLocal, function (o) {
            return o.code;
          });
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.alternateLocal] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.alternateLocal] });

    // Package options
    for (let j in this.selectCode.updatedCodes) {
      for (let k in this.packageOptions) {
        if ((this.selectCode.updatedCodes[j].code === this.packageOptions[k].code) && (this.selectCode.updatedCodes[j].codeType === this.packageOptions[k].codeType)) {
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.packageOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.packageOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.packageOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
         
          this.alternatePackage.push(this.packageOptions[k]);
          this.alternatePackage = _.uniqBy(this.alternatePackage, function (o) {
            return o.code;
          });
          this.checkAddEquipmentsInPackage(this.alternatePackage);
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.alternatePackage] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.alternatePackage] });

    //Local Package options
    for (let j in this.selectCode.updatedCodes) {
      for (let k in this.localPackageOptions) {
        if ((this.selectCode.updatedCodes[j].code === this.localPackageOptions[k].code) && (this.selectCode.updatedCodes[j].codeType === this.localPackageOptions[k].codeType)) {
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.localPackageOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.localPackageOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                   this.localPackageOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
          
          this.alternateLocalPackage.push(this.localPackageOptions[k]);
          this.alternateLocalPackage = _.uniqBy(this.alternateLocalPackage, function (o) {
            return o.code;
          });
          this.checkAddEquipmentsInPackage(this.alternateLocalPackage);
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.alternateLocalPackage] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.alternateLocalPackage] });

    //Standard options

    for (let j in this.selectCode.updatedCodes) {
      for (let k in this.standardOptions) {
        if ((this.selectCode.updatedCodes[j].code === this.standardOptions[k].code) && (this.selectCode.updatedCodes[j].codeType === this.standardOptions[k].codeType)) {
          //Updated Prices from validation response
            for (let s in this.dataLoaderService.gccUpdatedPrices) {
                if ((this.standardOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.standardOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
                  this.standardOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
                }
            }
        
          this.alternateStandard.push(this.standardOptions[k]);
          this.alternateStandard = _.uniqBy(this.alternateStandard, function (o) {
            return o.code;
          });
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.alternateStandard] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertStandard", data: [this.alternateStandard] });

    this.priceCalculationService.expertModePriceCalculation();

  }

  checkAddEquipmentsInPackage(equipments) {
    if (equipments.packagedEquipmentList != undefined)
      this.equipmentList = "packagedEquipmentList";
    else
      this.equipmentList = "localPackagedEquipmentList";
    for (let i in equipments[this.equipmentList]) {
      //factory inside package add equipments
      for (let k in this.factoryOptions) {
        if (equipments[this.equipmentList][i].code === this.factoryOptions[k].code) {
          this.factoryOptions[k].selected = true;
          this.alternateFactory.push(this.factoryOptions[k]);
          this.alternateFactory = _.uniqBy(this.alternateFactory, function (o) {
            return o.code;
          });
        }
      }
      this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.alternateFactory] });
      this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.alternateFactory] });

      //local inside package add equipments
      for (let k in this.localOptions) {
        if (equipments[this.equipmentList][i].code === this.localOptions[k].code) {
          this.localOptions[k].selected = true;
          this.alternateLocal.push(this.localOptions[k]);
          this.alternateLocal = _.uniqBy(this.alternateLocal, function (o) {
            return o.code;
          });
        }
      }
      this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.alternateLocal] });
      this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.alternateLocal] });

      //package inside package add equipments
      for (let k in this.packageOptions) {
        if (equipments[this.equipmentList][i].code === this.packageOptions[k].code) {
          this.packageOptions[k].selected = true;
          this.alternatePackage.push(this.packageOptions[k]);
          this.alternatePackage = _.uniqBy(this.alternatePackage, function (o) {
            return o.code;
          });
          this.checkAddEquipmentsInPackage(this.alternatePackage);
        }
      }
      this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.alternatePackage] });
      this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.alternatePackage] });

      //local package inside package add equipments
      for (let k in this.localPackageOptions) {
        if (equipments[this.equipmentList][i].code === this.localPackageOptions[k].code) {
          this.localPackageOptions[k].selected = true;
          this.alternateLocalPackage.push(this.localPackageOptions[k]);
          this.alternateLocalPackage = _.uniqBy(this.alternateLocalPackage, function (o) {
            return o.code;
          });
          this.checkAddEquipmentsInPackage(this.alternateLocalPackage);
        }
      }
      this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.alternateLocalPackage] });
      this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.alternateLocalPackage] });
    }
  }

  undoSelection() {
    // On Undo update the configuration ID
    this.alternateOptionsService.configurationId = this.dataLoaderService.intialConfigurationId

    if (this.selectCode != undefined) {
      this.dataLoaderService.flagDictionary.summaryValidate = false;
      this.dataLoaderService.flagDictionary.confirmValidateFlag = false;
      this.selectCode.selected = false;
      this.selectCode = undefined;
    }
    this.closePopup();
  }

  closeErrorPopup() {
    this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
    this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
    this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
    this.commonDataService.progressBarColorFlag = false;
    this.progressBarService.progressBarValidation();
  }
  removeCodesOnValidate(data) {

    for (let k in this.factoryOptions) {
      if (this.factoryOptions[k].selected) {
        this.alternateFactory.push(this.factoryOptions[k]);
      }
    }
    this.alternateFactory = _.uniqBy(this.alternateFactory, function (o) {
      return o.code;
    });
    for (let k in this.localOptions) {
      if (this.localOptions[k].selected) {
        this.alternateLocal.push(this.localOptions[k]);
      }
    }
    this.alternateLocal = _.uniqBy(this.alternateLocal, function (o) {
      return o.code;
    });

    for (let k in this.packageOptions) {
      if (this.packageOptions[k].selected) {
        this.alternatePackage.push(this.packageOptions[k]);
      }
    }
    this.alternatePackage = _.uniqBy(this.alternatePackage, function (o) {
      return o.code;
    });

    for (let k in this.localPackageOptions) {
      if (this.localPackageOptions[k].selected) {
        this.alternateLocalPackage.push(this.localPackageOptions[k]);
      }
    }
    this.alternateLocalPackage = _.uniqBy(this.alternateLocalPackage, function (o) {
      return o.code;
    });

    for (let k in this.standardOptions) {
      if (this.standardOptions[k].selected) {
        this.alternateStandard.push(this.standardOptions[k]);
      }
    }
    this.alternateStandard = _.uniqBy(this.alternateStandard, function (o) {
      return o.code;
    });

    //Color options
    for (let j in data) {
      for (let k in this.colorOptions) {
        if ((data[j].code === this.colorOptions[k].code) && (data[j].codeType === this.colorOptions[k].codeType)) {
          this.colorOptions[k].selected = false;
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertColor", data: [] });
        }
      }
    }

    //Additional Color options
    if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.addColorOptions.length > 0) {
      for (let j in data) {
        for (let k in this.addColorOptions) {
          if ((data[j].code === this.addColorOptions[k].code) && (data[j].codeType === this.addColorOptions[k].codeType)) {
            this.addColorOptions[k].selected = false;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: [] });
          }
        }
      }
    }

    //Trim options
    for (let j in data) {
      for (let k in this.trim) {
        if ((data[j].code === this.trim[k].code) && (data[j].codeType === this.trim[k].codeType)) {
          if (this.trim[k].selected) {
            this.trim[k].selected = false;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertTrim", data: [] });
          }
        }
      }
    }

    //Rim options
    for (let j in data) {
      for (let k in this.rim) {
        if ((data[j].code === this.rim[k].code) && (data[j].codeType === this.rim[k].codeType)) {
          if (this.rim[k].selected) {
            this.rim[k].selected = false;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertRim", data: [] });
          }
        }
      }
    }

    //Upholstery options
    for (let j in data) {
      for (let k in this.upholstery) {
        if ((data[j].code === this.upholstery[k].code) && (data[j].codeType === this.upholstery[k].codeType)) {
          this.upholstery[k].selected = false;
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: [] });
        }
      }
    }

    //Factory options
    for (let j in data) {
      for (let k in this.factoryOptions) {
        if ((data[j].code === this.factoryOptions[k].code) && (data[j].codeType === this.factoryOptions[k].codeType)) {
          this.factoryOptions[k].selected = false;
          for (let z in this.alternateFactory) {
            if (this.alternateFactory[z].code == this.factoryOptions[k].code)
              this.alternateFactory.splice(Number(z), 1);
          }
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.alternateFactory] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.alternateFactory] });

    //Local Options
    for (let j in data) {
      for (let k in this.localOptions) {
        if ((data[j].code === this.localOptions[k].code) && (data[j].codeType === this.localOptions[k].codeType)) {
          this.localOptions[k].selected = false;
          for (let z in this.alternateLocal) {
            if (this.alternateLocal[z].code == this.localOptions[k].code)
              this.alternateLocal.splice(Number(z), 1);
          }
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.alternateLocal] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.alternateLocal] });

    // Package Options
    for (let j in data) {
      for (let k in this.packageOptions) {
        if ((data[j].code === this.packageOptions[k].code) && (data[j].codeType === this.packageOptions[k].codeType)) {
          this.packageOptions[k].selected = false;
          for (let z in this.alternatePackage) {
            if (this.alternatePackage[z].code == this.packageOptions[k].code)
              this.alternatePackage.splice(Number(z), 1);
          }
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.alternatePackage] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.alternatePackage] });

    //Local Package options

    for (let j in data) {
      for (let k in this.localPackageOptions) {
        if((data[j].code === this.localPackageOptions[k].code) && (data[j].codeType === this.localPackageOptions[k].codeType)){
          this.localPackageOptions[k].selected = false;
          for (let z in this.alternateLocalPackage) {
            if (this.alternateLocalPackage[z].code == this.localPackageOptions[k].code) {
              this.alternateLocalPackage.splice(Number(z), 1);
            }
          }
        }
      }
    }

    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.alternateLocalPackage] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.alternateLocalPackage] });

    //Standard Options
    for (let j in data) {
      for (let k in this.standardOptions) {
        if ((data[j].code === this.standardOptions[k].code) && (data[j].codeType === this.standardOptions[k].codeType)) {
          this.standardOptions[k].selected = false;
          for (let z in this.alternateStandard) {
            if (this.alternateStandard[z].code == this.standardOptions[k].code)
              this.alternateStandard.splice(Number(z), 1);
          }
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.alternateStandard] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertStandard", data: [this.alternateStandard] });

    // this.addCodesOnValidate(this.data);
    this.addCodesOnValidate(this.dataLoaderService.addedCodes);
  }

  addCodesOnValidate(data) {
    //Color options:    
    for (let j in data) {
      for (let k in this.colorOptions) {
        if ((data[j].code === this.colorOptions[k].code) && (data[j].codeType === this.colorOptions[k].codeType)) {
          this.colorOptions.forEach(element => {
            element.selected = false;
          });
          this.colorOptions[k].selected = true;
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [this.colorOptions[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertColor", data: [this.colorOptions[k]] });
        }
      }
    }

    //Additional Color options:
    if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.addColorOptions.length > 0) {
      for (let j in data) {
        for (let k in this.addColorOptions) {
          if ((data[j].code === this.addColorOptions[k].code) && (data[j].codeType === this.addColorOptions[k].codeType)) {
            this.addColorOptions.forEach(element => {
              element.selected = false;
            });
            this.addColorOptions[k].selected = true;
            this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [this.addColorOptions[k]] });
            this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: [this.addColorOptions[k]] });
          }
        }
      }
    }

    //Rim options:    
    for (let j in data) {
      for (let k in this.rim) {
        if ((data[j].code === this.rim[k].code) && (data[j].codeType === this.rim[k].codeType)) {
          this.rim.forEach(element => {
            element.selected = false;
          });
          this.rim[k].selected = true;
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [this.rim[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertRim", data: [this.rim[k]] });
        }
      }
    }

    //Upholstery options:    
    for (let j in data) {
      for (let k in this.upholstery) {
        if ((data[j].code === this.upholstery[k].code) && (data[j].codeType === this.upholstery[k].codeType)) {
          this.upholstery.forEach(element => {
            element.selected = false;
          });
          this.upholstery[k].selected = true;
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [this.upholstery[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: [this.upholstery[k]] });
        }
      }
    }

    //Trim options:
    for (let j in data) {
      for (let k in this.trim) {
        if ((data[j].code === this.trim[k].code) && (data[j].codeType === this.trim[k].codeType)) {
          this.trim.forEach(element => {
            element.selected = false;
          });
          this.trim[k].selected = true;
          this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [this.trim[k]] });
          this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertTrim", data: [this.trim[k]] });
        }
      }
    }

    //Factory options

    for (let j in data) {
      for (let k in this.factoryOptions) {
        if ((data[j].code === this.factoryOptions[k].code) && (data[j].codeType === this.factoryOptions[k].codeType)) {
          this.factoryOptions[k].selected = true;
          this.alternateFactory.push(this.factoryOptions[k]);
          this.alternateFactory = _.uniqBy(this.alternateFactory, function (o) {
            return o.code;
          });
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.alternateFactory] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.alternateFactory] });


    // Local Options

    for (let j in data) {
      for (let k in this.localOptions) {
        if ((data[j].code === this.localOptions[k].code) && (data[j].codeType === this.localOptions[k].codeType)) {
          this.localOptions[k].selected = true;
          this.alternateLocal.push(this.localOptions[k]);
          this.alternateLocal = _.uniqBy(this.alternateLocal, function (o) {
            return o.code;
          });
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.alternateLocal] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.alternateLocal] });

    // Package options
    for (let j in data) {
      for (let k in this.packageOptions) {
        if ((data[j].code === this.packageOptions[k].code) && (data[j].codeType === this.packageOptions[k].codeType)) {
          this.packageOptions[k].selected = true;
          this.alternatePackage.push(this.packageOptions[k]);
          this.alternatePackage = _.uniqBy(this.alternatePackage, function (o) {
            return o.code;
          });
          this.checkAddEquipmentsInPackage(this.alternatePackage);
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.alternatePackage] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.alternatePackage] });

    //Local Package options
    for (let j in data) {
      for (let k in this.localPackageOptions) {
        if ((data[j].code === this.localPackageOptions[k].code) && (data[j].codeType === this.localPackageOptions[k].codeType)) {
          this.localPackageOptions[k].selected = true;
          this.alternateLocalPackage.push(this.localPackageOptions[k]);
          this.alternateLocalPackage = _.uniqBy(this.alternateLocalPackage, function (o) {
            return o.code;
          });
          this.checkAddEquipmentsInPackage(this.alternateLocalPackage);
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.alternateLocalPackage] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.alternateLocalPackage] });

    //Standard options

    for (let j in data) {
      for (let k in this.standardOptions) {
        if ((data[j].code === this.standardOptions[k].code) && (data[j].codeType === this.standardOptions[k].codeType)) {
          this.standardOptions[k].selected = true;
          this.alternateStandard.push(this.standardOptions[k]);
          this.alternateStandard = _.uniqBy(this.alternateStandard, function (o) {
            return o.code;
          });
        }
      }
    }
    this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.alternateStandard] });
    this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertStandard", data: [this.alternateStandard] });

    this.priceCalculationService.normalModePriceCalculation();
    this.selectCode = undefined;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/alternate-options/alternate-options.component.ts